<template>
  <div>
    <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
      <a-row :gutter="10" style="margin: 8px 0 0 0;">
        <a-col :xs="24" :lg="8">
          <span class="form-row-title">Travel Doc.</span>
        </a-col>
        <!-- <a-col :xs="24" :lg="4">
          <span class="form-row-title"> </span>
        </a-col> -->
        <a-col :xs="24" :lg="3">
          <span class="form-row-title">Exp. Date</span>
        </a-col>
        <a-col :xs="24" :lg="4">
          <span class="form-row-title">Surname</span>
        </a-col>
        <a-col :xs="24" :lg="4">
          <span class="form-row-title">Given Names</span>
        </a-col>
        <a-col :xs="24" :lg="3" v-show="false">
          <span class="form-row-title">Middle</span>
        </a-col>
        <a-col :xs="24" :lg="4">
          <span class="form-row-title">DOB</span>
        </a-col>
        <a-col :xs="24" :lg="1">
        </a-col>
      </a-row>
      <a-row :gutter="10" v-for="(p, pindex) in datas" :key="'passport-row-' + pindex">
        <!-- 护照类型 -->
        <a-col :xs="24" :lg="8" style="display:flex;padding-right: 0;">
          <a-form-item>
              <a-select
                :dropdownMatchSelectWidth="false"
                style="width: 140px;"
                :showSearch="true"
                optionFilterProp="children"
                v-decorator="[
                  'passport-' + pindex + '-countryId',
                  { 
                    initialValue: p.countryId,
                    rules: [{ required: false, message: 'Please select your travel Doc.' }] },
                ]"
              >
                <a-select-option v-for="i in PassportTravelDocList" :key="'country-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
              </a-select>
            </a-form-item>
            <!-- 护照号码 -->
            <a-form-item style="width: 100%;">
              <a-input
                @change="handlePassportNumberChange"
                placeholder="Numbers"
                style="margin-left: -5px;border-bottom-left-radius: 0;border-top-left-radius: 0;"
                :maxLength="30"
                v-decorator="[
                  'passport-' + pindex + '-passportNumber',
                  {
                    initialValue: p.passportNumber ? p.passportNumber : '',
                    rules: [{ required: false, message: 'Please input your travel Doc. No.' }]}
                ]"
                ></a-input>
            </a-form-item>
        </a-col>
        <!-- 护照有效期 -->
        <a-col :xs="24" :lg="3">
          <a-form-item
            :validateStatus="p.expirationDateValidateStatus"
            :help="p.expirationDateValidateHelp"
          >
          <a-input
            placeholder="mm/dd/yyyy"
            :maxLength="10"
            @change="handleDateChange(pindex, 'expirationDate', $event)"
            @blur="handleInputDateBlur(pindex, 'expirationDate')"
            v-decorator="['passport-' + pindex + '-expirationDate', {initialValue: p.expirationDate ? p.expirationDate : '',}]" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :lg="4">
          <!-- Last Name -->
          <a-form-item>
            <a-input
              @change="handleNameChange"
              v-decorator="[
                'passport-' + pindex + '-lastName',
                {
                  initialValue: p.lastName ? p.lastName : '',
                  rules: [
                    {
                      required: false,
                      message: 'Please input your surname.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- First Name -->
        <a-col :xs="24" :lg="4">
          <a-form-item>
            <a-input
              @change="handleNameChange"
              v-decorator="[
                'passport-' + pindex + '-firstName',
                {
                  initialValue: p.firstName ? p.firstName : '',
                  rules: [
                    {
                      required: false,
                      message: 'Please input your given names.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- Middle Name -->
        <a-col :xs="24" :lg="3" v-show="false">
          <a-form-item>
            <a-input
              @change="handleNameChange"
              v-decorator="[
                'passport-' + pindex + '-middleName',
                {
                  initialValue: p.middleName ? p.middleName : '',
                  rules: [
                    {
                      required: false,
                      message: 'Please input your middle name.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :lg="3">
          <a-form-item
            :validateStatus="p.birthdayValidateStatus"
            :help="p.birthdayValidateHelp"
          >
          <a-input
            placeholder="mm/dd/yyyy"
            :maxLength="10"
            @change="handleDateChange(pindex, 'birthday', $event)"
            @blur="handleInputDateBlur(pindex, 'birthday')"
            v-decorator="['passport-' + pindex + '-birthday', {initialValue: p.birthday ? p.birthday : '',}]"
          />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :lg="2" style="padding-left: 10px;padding-right: 0;text-align: left;">
          <a @click="handlePassportAdd" class="cdb-customer-add" v-if="pindex === (datas.length-1)">
          <a-icon type="plus"/>
        </a>
        <a-popconfirm
          title="Are you sure?"
          ok-text="Yes"
          cancel-text="No"
          @confirm="handlePassportDelete(pindex)"
        >
          <a class="cdb-customer-add" v-if="(pindex !== (datas.length-1) || pindex === (datas.length-1)) && datas.length >1"><a-icon type="delete" /></a>
        </a-popconfirm>
        </a-col>
        <!-- 隐藏 -->
        <a-form-item v-show="false">
          <a-input v-decorator="['passport-' + pindex + '-internalCode',{initialValue: p.internalCode ? p.internalCode : '', rules: [{ required: false}]}]"/>
      </a-form-item>
      </a-row>
    </a-form>
  </div>
</template>

<script>
/* import CountryApi from '@/api/basicdata/api-country' */
// import { PassportTravelDocType } from '@/utils/helper/standard-code-utils'
import { TravelDoc } from '@/utils/helper/dict-cdb-utils'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'CdbCustomerPassport',
  components: {
  },
  props: {
    initData: {
      type: [Array],
      default: null
    },
    customerBirthday: {
      type: [String],
      default: null
    }
  },
  data () {
    return {
      editForm: this.$form.createForm(this),
      visible: false,
      datas: null,
      currentPassportIndex: 0,
      PassportTravelDocList: null,
      passportList: [],
      // 客人生日是否有效,客人生日格式错误提示语
      birthdayValid: {
        status: 'success',
        help: ''
			},
      // 客人生日 mm/dd/yyyy
      localCustomerBirthday: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData() {
      // 护照类别
      this.PassportTravelDocList = await TravelDoc.getDict()
      let customerBirthday = this.customerBirthday
      if (customerBirthday && customerBirthday != '') {
        if (customerBirthday.indexOf('/') > 0) {
          customerBirthday = moment(customerBirthday, 'MM/DD/YYYY').format('MM/DD/YYYY')
        } else {
          customerBirthday = moment(customerBirthday).format('MM/DD/YYYY')
        }
      }
      this.localCustomerBirthday = customerBirthday
      this.datas = null
      const datas = this.copyDataByJSON(this.initData)
      let passportList = datas
      if (!passportList || passportList.length === 0) {
        passportList = []
        const defaultValue = { internalCode: this.generateUuid(), countryId: '', passportNumber: null, firstName: null, lastName: null, middleName: null, expirationDate: null, birthday: customerBirthday}
        defaultValue.expirationDateValidateStatus = 'success'
        defaultValue.expirationDateValidateHelp = ''
        defaultValue.birthdayValidateStatus = 'success'
        defaultValue.birthdayValidateHelp = ''
        passportList.push(defaultValue)
      } else {
        for (let i=0; i< passportList.length; i++) {
          // passportList[i].country = PassportTravelDocType.getByCode(datas[i].countryId)
          if (passportList[i].birthday) {
            if (passportList[i].birthday.indexOf('/') > 0) {
              passportList[i].birthday = moment(passportList[i].birthday, 'MM/DD/YYYY').format('MM/DD/YYYY')
              } else {
                passportList[i].birthday = moment(passportList[i].birthday).format('MM/DD/YYYY')
              }
              passportList[i].birthdayValidateStatus = 'success'
              passportList[i].birthdayValidateHelp = ''
          }
          if (passportList[i].expirationDate) {
            if (passportList[i].expirationDate.indexOf('/') > 0) {
                passportList[i].expirationDate = moment(passportList[i].expirationDate, 'MM/DD/YYYY').format('MM/DD/YYYY')
              } else {
                passportList[i].expirationDate = moment(passportList[i].expirationDate).format('MM/DD/YYYY')
              }
              passportList[i].expirationDateValidateStatus = 'success'
              passportList[i].expirationDateValidateHelp = ''
          }
        }
      }
      this.datas = passportList
      this.birthdayValid.status = 'success'
      this.birthdayValid.help = ''
    },
    // 添加护照号
    handlePassportAdd () {
      this.datas.push({ internalCode: this.generateUuid(), countryId: '', passportNumber: null, firstName: null, lastName: null, middleName: null, expirationDate: null, birthday: this.localCustomerBirthday})
    },
    // 处理日期控件失去焦点校验
    handleInputDateBlur(pindex, name) {
      const value = this.editForm.getFieldValue('passport-' + pindex + '-' + name)
      // 日期格式
      const DATE_REG = /^(((0?[13578]|1[02])\/(0?[1-9]|[12]\d|3[01])\/((1[6-9]|[2-9]\d)\d{2}))|((0?[13456789]|1[012])\/(0?[1-9]|[12]\d|30)\/((1[6-9]|[2-9]\d)\d{2}))|(0?2\/(0?[1-9]|1\d|2[0-8])\/((1[6-9]|[2-9]\d)\d{2}))|(0?2\/29\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/
      let valid = false
      const el = this.copyDataByJSON(this.datas[pindex])
      if (!value || value.length === 0) {
        // el[name + 'ValidateStatus'] = 'error'
          if (name === 'expirationDate') {
            // el[name + 'ValidateHelp'] = 'Please input expiration!'
          } else {
            // el[name + 'ValidateHelp'] = 'Please input birthday!'
          }
        return true
      } else {
        if (DATE_REG.test(value)) {
          if (name !== 'expirationDate') {
            // 判断生日是否大于当前日期
            const bd = moment(value, 'MM/DD/YYYY')
            const now = moment(moment(new Date()).format('MM/DD/YYYY'), 'MM/DD/YYYY')
            const diff = bd.diff(now, 'days')
            if (diff > 0) {
              el[name + 'ValidateStatus'] = 'error'
              el[name + 'ValidateHelp'] = 'Invalid birthday!'
              valid = false
            } else {
              el[name + 'ValidateStatus'] = 'success'
              el[name + 'ValidateHelp'] = ''
              valid = true
            }
          } else {
            el[name + 'ValidateStatus'] = 'success'
            el[name + 'ValidateHelp'] = ''
            valid = true
          }
        } else {
          el[name + 'ValidateStatus'] = 'error'
          el[name + 'ValidateHelp'] = 'Invalid date format!'
          valid = false
        }
      }
      this.$set(this.datas, pindex, el)
      return valid
    },
    // 处理了日期变化
    handleDateChange (pindex, name, e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/([^0-9|\\/])/, '')
        if (/^[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        if (/^[0-9]{2}\/[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        e.target.value = newValue
        this.$nextTick(() => {
          if (newValue.length === 10) {
            this.handleInputDateBlur(pindex, name)
          }
        })
      }
    },
    // 处理了名字变化
    handleNameChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/[^a-zA-Z ]/g, '')
        if (newValue !== '') {
          let newValueArrey = newValue.split(' ')
          newValueArrey = newValueArrey.map(n => {
            return _.capitalize(n)
          })
          newValue = newValueArrey.join(' ')
        }
        e.target.value = newValue
      }
    },
    handlePassportNumberChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        const newValue = value.replace(/[^\w]/ig,'')
        e.target.value = newValue
      }
    },
    handleSubmit (e) {
      e.preventDefault()
    },
    handlePassportDelete (pindex) {
      this.datas.splice(pindex, 1)
    },
    getPassportTravelDoc (id) {
      const passportTravelDocList = this.passportTravelDocList
      if (passportTravelDocList && passportTravelDocList.length > 0) {
        for(let i=0; i < passportTravelDocList.length; i++) {
          const c = passportTravelDocList[i]
          if (id === c.code) {
            return {
              id: c.code,
              code: c.enName,
              nameEnUs: c.enName
            }
          }
        }
        return null
      } else {
        return null
      }
    },
    preValidateForm () {
      const that = this
      const editForm = that.editForm
      return new Promise((resolve, reject) => {
        editForm.validateFields((err) => {
          // 自定义校验
          let formIsValid = true
          if (err) {
            formIsValid = false
          }
          try {
            // 校验护照过期日和生日
            for (let i = 0; i < this.datas.length; i++) {
              const passport = this.datas[i]
              passport.expirationDate = editForm.getFieldValue('passport-' + i + '-expirationDate')
              passport.birthday = editForm.getFieldValue('passport-' + i + '-birthday')
              if (!this.handleInputDateBlur(i, 'expirationDate') || !this.handleInputDateBlur(i, 'birthday')) {
                formIsValid = false
              }
            }
            if (formIsValid) {
              resolve(formIsValid)
            } else {
              reject()
            }
          } catch (e) {
						console.log('preValidateForm error', e)
					}
          return
        })
      })
    },
    // 父组件调用校验方法
    validateForm () {
      const that = this
      const editForm = that.editForm
      return new Promise((resolve, reject) => {
        editForm.validateFields((err) => {
          if (err) {
            reject()
            return
          }
          try {
            // 获取护照列表
            const newPassportList = []
            let dateFormatValid = true
            for (let i = 0; i < this.datas.length; i++) {
                const passport = {}
                passport.internalCode = editForm.getFieldValue('passport-' + i + '-internalCode')
                passport.countryId = editForm.getFieldValue('passport-' + i + '-countryId')
                passport.firstName = editForm.getFieldValue('passport-' + i + '-firstName')
                passport.lastName = editForm.getFieldValue('passport-' + i + '-lastName')
                passport.middleName = editForm.getFieldValue('passport-' + i + '-middleName')
                passport.passportNumber = editForm.getFieldValue('passport-' + i + '-passportNumber')
                passport.expirationDate = editForm.getFieldValue('passport-' + i + '-expirationDate')
                passport.birthday = editForm.getFieldValue('passport-' + i + '-birthday')
                
                if (!this.handleInputDateBlur(i, 'expirationDate') || !this.handleInputDateBlur(i, 'birthday')) {
                  dateFormatValid = false
                } else {
                  // 更换为手动输入不用转moment
                  passport.expirationDate = moment(passport.expirationDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
                  // 更换为手动输入不用转moment
                  passport.birthday = moment(passport.birthday, 'MM/DD/YYYY').format('YYYY-MM-DD')
                  if (passport.expirationDate === 'Invalid date') {
                    passport.expirationDate = null
                  }
                  if (passport.birthday === 'Invalid date') {
                    passport.birthday = null
                  }
                }
                passport.passportType = 'A'
                // 获取国家信息
                passport.country = this.getPassportTravelDoc(passport.countryId)
                newPassportList.push(passport)
            }
            // 只要有一个日期格式不正确就校验失败
            if (!dateFormatValid) {
              reject()
              return
            }
            resolve(newPassportList)
            return
          } catch (e) {
            console.log('cdb get form data error', e)
            reject(e)
            return
          }
        })
      })
    }
  },
  watch: {
    initData () {
      this.loadData()
    },
    customerBirthday (newValue) {
      let customerBirthday = newValue
      if (customerBirthday && customerBirthday != '') {
        if (customerBirthday.indexOf('/') > 0) {
          customerBirthday = moment(customerBirthday, 'MM/DD/YYYY').format('MM/DD/YYYY')
        } else {
          customerBirthday = moment(customerBirthday).format('MM/DD/YYYY')
        }
      }
      this.localCustomerBirthday = customerBirthday
    }
  }
}
</script>
<style lang="less" scoped>
.form-row-title {
  font-weight: 600;
  color: rgba(0,0,0,.85);
  line-height: 30px;
}
.cdb-customer-add {
	height: 40px;
  padding-right: 10px;
	line-height: 40px;
	display: inline-block;
}
</style>
